import React, { useMemo, useState } from 'react'

import { FilterActions, InitialFilterState, JobsFilters as JobsFiltersType, useFiltersContext } from '@/context'

import { ApplyButton, ClearButton, FilterOption, RadioFilterOption } from './components'

type keys = keyof JobsFiltersType

type Props = {
  multiSelect?: boolean
  onClose: () => void
}
const JobsFilters = ({ onClose, multiSelect = false }: Props) => {
  const [{ jobsFilters }, FilterDispatch] = useFiltersContext()
  const [filterOptions, setFilterOptions] = useState(jobsFilters)

  const onSelectFilter = (selectedOption: { [key in keys]: boolean }) => {
    if (multiSelect) {
      setFilterOptions((prev) => ({ ...prev, ...selectedOption }))
    } else {
      setFilterOptions({ ...InitialFilterState['jobsFilters'], ...selectedOption })
    }
  }

  const onApply = () => {
    FilterDispatch(FilterActions.setFilters({ filterName: 'jobs', filters: filterOptions }))
    onClose()
  }

  const onClear = () => {
    FilterDispatch(FilterActions.clearFilters({ filterName: 'jobs' }))
    onClose()
  }

  const showClearButton = useMemo(() => Object.keys(filterOptions).find((key) => !!filterOptions[key]), [filterOptions])

  return (
    <>
      <RadioFilterOption
        onSelect={onSelectFilter}
        options={[
          { label: 'Unclaimed', name: 'unclaimed', value: filterOptions['unclaimed'] },
          { label: 'Claimed', name: 'claimed', value: filterOptions['claimed'] },
        ]}
      />
      <FilterOption label="Future" name="future" onSelect={onSelectFilter} value={filterOptions['future']} />
      <FilterOption label="Next 7 days" name="next7Days" onSelect={onSelectFilter} value={filterOptions['next7Days']} />
      <FilterOption label="Cancelled" name="cancelled" onSelect={onSelectFilter} value={filterOptions['cancelled']} />
      {showClearButton && <ClearButton onClick={onClear} />}
      <ApplyButton onClick={onApply} />
    </>
  )
}

export default JobsFilters
